import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { IsActive } from 'components/Chip'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { PlanActions } from './Actions'
import { ReactElement } from 'react'
import { GTKolorsMobilePlanItem } from 'gql/types.generated'
import { useLogin } from 'features/Login/hooks'

const NoWrap = styled.div`
  white-space: nowrap;
`
const Photo = styled.img`
  width: auto;
  max-width: 100px;
  height: 40px;
`

export function PlansList({ planItems = [] }: { planItems: GTKolorsMobilePlanItem[] }): ReactElement {
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.ITEM, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="spanish.dictionary.photo" defaultMessage="Foto" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.status" defaultMessage="Status" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.planId" defaultMessage="Plan ID" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.sellingPrice" defaultMessage="Precio de venta" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {planItems.map((planItem): ReactElement => {
            return (
              <Tr key={planItem.id}>
                {canWrite(FEATURES.ITEM, login.accessToken.policies) && (
                  <Td>
                    <PlanActions plan={planItem} />
                  </Td>
                )}
                <Td>
                  <Photo alt={planItem.name} src={planItem.photoPath} />
                </Td>
                <Td>
                  <NoWrap>{planItem.name}</NoWrap>
                </Td>
                <Td>
                  <IsActive isActive={planItem.isActive} />
                </Td>
                <Td>{planItem.planID}</Td>
                <Td>
                  <FormattedPrice value={planItem.sellingPrice} />
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
